import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Dashboard
export const AllTotalEnquirys = createAsyncThunk(
  "common/dashboard/all-totalenquirys",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTotalEnquirys);

      return res?.data?.total_enquirys || 0;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "totalenquirys",

  initialState: {
    totalenquirys: 0,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      // Pending
      .addCase(AllTotalEnquirys.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      // Success
      .addCase(AllTotalEnquirys.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.totalenquirys = action.payload;
      })

      // Failed
      .addCase(AllTotalEnquirys.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
